export default class OverviewController {
    /* @ngInject */
    constructor(MapService, AuthService) {
        this.MapService = MapService;
        this.AuthService = AuthService;
        this.showDetailsLink = true;
    }

    $onInit() {
        if (this.AuthService.isTransportChief()) {
            this.showDetailsLink = false;
        }
    }

    focused(thingId) {
        this.MapService.showPopup(thingId);
    }
}



// WEBPACK FOOTER //
// ./src/app/home/overview-list/overview-list.controller.js